import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    const checked = this.element.querySelector("input[type=radio]:checked")
    if (checked) this.showForValue(checked.value)
  }

  update(event) {
    this.showForValue(event.currentTarget.value)
  }

  showForValue(value) {
    this.panelTargets.forEach((el) => {
      el.hidden = el.dataset.value !== value
    })
  }
}
